import React, { useLayoutEffect } from 'react';
import { submit } from 'lib/utility';
import ConfigStore from 'lib/stores/configStore';
import useFormValid from 'lib/hooks/useFormValid';

import SubmitButton from '../SubmitButton';
import FormAddressSearch from './FormAddressSearch';
import FormAttachment from './FormAttachment';
import FormBadgeMultiSelect from './FormBadgeMultiSelect';
import FormCheckbox from './FormCheckbox';
import FormDatePicker from './FormDatePicker';
import FormEmailField from './FormEmailField';
import FormNumber from './FormNumber';
import FormPlaceSearch from './FormPlaceSearch';
import FormRadio from './FormRadio';
import FormRadioUploader from './FormRadioUploader';
import FormPhoneField from './FormPhoneField';
import FormPasswordField from './FormPasswordField';
import FormSearchField from './FormSearchField';
import FormSelectField from './FormSelectField';
import FormSubmit from './FormSubmit';
import FormTextArea from './FormTextArea';
import FormTextField from './FormTextField';
import FormTimePicker from './FormTimePicker';
import FormImageUploader from './FormImageUploader';

import WizardStepper from '../WizardStepper';

const Form = props => {
  const {
    onSubmit,
    stepDispatch,
    page,
    hideNext,
    hideBack,
    children,
    backLabel = 'Back',
    nextLabel = 'Next',
    as = 'form',
    validate = false,
  } = props;

  const Component = as;

  const [formValid] = useFormValid(page.toLowerCase());

  const goBack = () => { stepDispatch({ type: 'PREV_STEP' }); };
  const goNext = () => { stepDispatch({ type: 'NEXT_STEP' }); };

  const isForm = as === 'form';

  const handleSubmit = async e => {
    e.preventDefault();

    submit(async () => {
      if (onSubmit) { await onSubmit(); }
      if (!stepDispatch) return;

      goNext();
    });
  };

  useLayoutEffect(() => {
    ConfigStore.update(s => { s.currentPage = page.toLowerCase(); });
  }, []);

  return (
    <>
      <Component onSubmit={isForm ? handleSubmit : undefined}>
        {children}
        <div className="d-flex justify-content-between">
          {!hideBack && (
            <button type="button" className="btn btn-primary mt-3" data-testid="back" onClick={goBack}>
              {backLabel}
            </button>
          )}
          <WizardStepper />
          {!hideNext && (
            isForm ? (
              <SubmitButton
                trackingContext={page.toLowerCase()}
                formId={isForm}
                label={nextLabel}
                disabled={!formValid}
              />
            ) : (
              <SubmitButton
                trackingContext={page.toLowerCase()}
                label={nextLabel}
                onClick={() => goNext()}
                disabled={validate ? !formValid : false}
              />
            )
          )}
        </div>
      </Component>
    </>
  );
};

Form.Address = FormAddressSearch;
Form.Attachment = FormAttachment;
Form.Place = FormPlaceSearch;
Form.MultiSelect = FormBadgeMultiSelect;
Form.Checkbox = FormCheckbox;
Form.Date = FormDatePicker;
Form.Email = FormEmailField;
Form.Radio = FormRadio;
Form.RadioUploader = FormRadioUploader;
Form.Phone = FormPhoneField;
Form.Password = FormPasswordField;
Form.Search = FormSearchField;
Form.Select = FormSelectField;
Form.Submit = FormSubmit;
Form.TextArea = FormTextArea;
Form.Text = FormTextField;
Form.Number = FormNumber;
Form.Time = FormTimePicker;
Form.ImageUploader = FormImageUploader;

export default Form;
